import { localize } from '@/core/filters';

export function getTreeCaption(treeKey: string): string {
    treeKey = treeKey.replace(new RegExp('-', 'g'), '_').toUpperCase();

    return localize(`${treeKey}_CAPTION`);
}

export function getParentId(parentId: any): string {
    return typeof parentId[1] === 'string' ? parentId[1] : getParentId(parentId[1]);
}

export function getNodesFlattenRecursive(nodes: any) {
    let result: any[] = [];

    if (nodes) {
        nodes.map((node: any) => {
            result.push(node.itemData);
            if (node.children.length > 0) {
                result = result.concat(getNodesFlattenRecursive(node.children));
            }
        });
    }

    return result;
}

export function prepareFilters(filterData: any): string {
    let filterString = '';

    if (filterData.length === 0) {
        return '';
    }

    filterData.forEach((element: any) => {
        if (typeof element === 'string') {
            filterString += calculateComparator(element);
        }
        if (typeof element === 'object') {
            filterString += prepareFilters(element);
        }
    });

    return filterString;
}

function calculateComparator(value: string) {
    switch (value) {
        case 'and': {
            return ';';
        }
        case 'contains':
        case 'notcontains':
        case 'startswith':
        case 'endswith':
        case '=':
        case '<>': {
            return '|' + value + '|';
        }
        default: {
            return value;
        }
    }
}
